<template>
    <v-app>
    <v-app-bar
      app
      flat
      color="white"
      elevation="0"
      class="noprint app-topbar"
    >

        <v-app-bar-nav-icon class="hovp d-flex d-md-none" color="#FB8C00" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <div class="align-center text-uppercase d-flex">
            <a href="/" rel="noopener noreferrer">
                <v-img
                alt="Logo"
                class="shrink mr-2"
                contain
                src="/images/myschlogo.png"
                transition="scale-transition"
                width="40"
                />
            </a>
            <div class="topbar-module-label d-none d-sm-flex align-center">
                <span class="module-dot"></span>
                <span>Lesson Notes Module</span>
            </div>
        </div>
        <v-spacer></v-spacer>

        <guest-menu-card-2 class="d-none d-sm-flex" v-if="isLoggedIn === false && isTokenAccess === false"/>
        <l-n-top-menu-card v-if="isLoggedIn === true" />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      dark
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      width="290"
      class="noprint app-sidebar"
    >
      <div class="sidebar-module-badge ma-4 pa-3 rounded-lg">
        <div class="text-overline white--text font-weight-bold text-center">Lesson Notes Module</div>
      </div>
      <v-divider class="sidebar-divider mb-2"></v-divider>
      <guest-menu-card v-if="isLoggedIn === false && isTokenAccess === false"/>
      <token-user-menu-card v-if="isLoggedIn === false && isTokenAccess === true"/>
      <l-n-side-menu-card v-if="isLoggedIn === true"/>

      <sidebar-footer/>
    </v-navigation-drawer>

    <v-main>
        <l-n-header class="text-center"/>
      <router-view/>
    </v-main>
  </v-app>
</template>
  
<script>
import { mapState } from "vuex";
import GuestMenuCard from '../components/GuestMenuCard.vue';
import GuestMenuCard2 from '../components/GuestMenuCard2.vue';
import LNHeader from '../components/lessonNote/LNHeader.vue';
import LNSideMenuCard from '../components/lessonNote/LNSideMenuCard.vue';
import LNTopMenuCard from '../components/lessonNote/LNTopMenuCard.vue';
import SidebarFooter from '../components/SidebarFooter.vue';
import TokenUserMenuCard from '../components/TokenUserMenuCard.vue';

export default {
  components: { GuestMenuCard2, GuestMenuCard, TokenUserMenuCard, LNHeader, LNTopMenuCard, LNSideMenuCard, SidebarFooter },
    name: 'Dashboard',

    data: () => ({
        drawer: false,
        group: null
    }),
    computed: {
        ...mapState({
        isLoggedIn: (state) => state.isLoggedIn,
        isTokenAccess: (state) => state.isTokenAccess,
        emailVerified: (state) => state.emailVerified,
        }),
        school (){
            if (this.isLoggedIn == true) {
                return JSON.parse(localStorage.getItem('school'))
            }
            return JSON.parse(localStorage.getItem('school'))
        },
        user (){
            if (this.isLoggedIn == true) {
                return JSON.parse(sessionStorage.getItem('loggedUser'))
            }
            return JSON.parse(sessionStorage.getItem('loggedUser'))
        }
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    watch: {
        group () {
            this.drawer = false
        }
    },
    methods:{
    }
};
</script>

<style scoped>
.app-topbar{
    border-bottom: 1px solid #ECEFF7;
}
.module-dot{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FB8C00;
    margin-right: 10px;
    flex-shrink: 0;
}
.topbar-module-label{
    color: #1E3C72;
    font-weight: 700;
    font-size: 0.72rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-left: 16px;
}
.app-sidebar{
    background: linear-gradient(180deg, #1E3C72 0%, #14233F 100%) !important;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
}
.sidebar-module-badge{
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    text-align: center;
    position: relative;
}
.sidebar-module-badge::after{
    content: '';
    display: block;
    width: 28px;
    height: 3px;
    margin: 8px auto 0;
    border-radius: 2px;
    background: #FB8C00;
}
.sidebar-module-badge .text-overline{
    letter-spacing: 2px;
    line-height: 1.4;
}
.sidebar-divider{
    border-color: rgba(255, 255, 255, 0.1) !important;
}
</style>

  